/**
 * @description 卡片容器，包裹图表组件，展示标题、图表类型切换、分享等功能
 */
import React from 'react'
import clsx from 'clsx'

interface Props {
  className?: string
  bodyClassName?: string
  title: string
  children: React.ReactNode
}

function Card(props: Props) {
  return (
    <div
      className={clsx(
        'card rounded-tremor-default group flex flex-col rounded-xl bg-white dark:bg-slate-700',
        props.className,
      )}
    >
      <div className="card-header flex items-center pb-0 text-left">
        <div className="card-title grow text-lg dark:text-white">{props.title}</div>
      </div>
      <div className={clsx('card-body overflow-hidden', props.bodyClassName)}>{props.children}</div>
    </div>
  )
}

export default Card
